<!--
 * @Author: houmy
 * @Date: 2023-10-19 11:42:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-20 15:26:51
 * @FilePath: \zx-home\src\components\Contact.vue
 * @Description: 
 * 
-->
<template>
    <div class="page">
        <div class="contactIcon" @click="handleShowContact">
            <div class="contactText">
                联系我们
            </div>
        </div>
        <div class="contactModel" v-show="showContact">
            <div class="contactTitle">
                <h3>联系我们</h3>
                <img class="cur-poi" @click="handleCloseContact" src="../assets/img/close.png" alt="">
            </div>
            <div class="contactModelMain">
                <ul class="flex-row">
                    <li class="flex-col">
                        <label>微信咨询</label>
                        <img src="../assets/img/weixin.png" alt="">
                    </li>
                    <li class="flex-col">
                        <label>关注我们</label>
                        <img src="../assets/img/guanzhu.jpg" alt="">
                    </li>
                </ul>
                <p>
                    <span>联系我们：13974811172（微信同号）</span>
                    <span>邮箱：raojy@sforceauto.com</span>
                </p>
                <p>公司地址：广东省佛山市顺德区陈村镇莱茵科技园3栋702</p>
            </div>
        </div>

    </div>
</template>
    
<script>
export default {
    components: {
    },
    data() {
        return {
            showContact: false

        };
    },
    methods: {
        // 显示弹窗
        handleShowContact() {
            this.showContact = true
        },
        // 关闭弹窗
        handleCloseContact(){
            this.showContact = false
        }
    }
};
</script>
    
<style scoped></style>


// WEBPACK FOOTER //
// src/components/Contact.vue